// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"1b15de73","766":"cbdf553b","805":"29b36a29","856":"7b774199","868":"4286dd32","935":"d3c017f2","971":"35e11b16"}[chunkId] + ".js";
};